"use client";

import { Fragment } from "react";
import LibraryIcon, { type LibraryIconName } from "@/components/ui/LibraryIcon";
import { useGlyphMode } from "@/lib/glyph-mode";

/** 絵文字ごとの線のアイコン。アプリでは絵文字そのものは出さない（ここに無い絵文字は出さない） */
export const EMOJI_ICONS: Record<string, LibraryIconName> = {
  "🏛": "library", "🗺": "map", "📖": "book", "📚": "shelf", "✨": "spirit", "🎁": "gift",
  "🔒": "lock", "🔓": "unlock", "🚫": "ban", "💎": "gem", "⚠": "warning", "🎲": "dice", "📔": "notebook",
  "📕": "closedBook", "📦": "box", "🌟": "star", "🔮": "crystal", "✋": "hand", "🖐": "hand", "🕊": "dove",
  "🌱": "sprout", "🗝": "key", "🤝": "handshake", "🧭": "compass", "🧺": "basket", "🎯": "target",
  "📅": "calendar", "🖼": "picture", "⬆": "up", "🔄": "cycle", "🌸": "blossom",
};

const strip = (e: string) => e.replace(/\uFE0F/g, "");
const ESCAPE = /[.*+?^${}()|[\]\\]/g;
const EMOJI_PATTERN = new RegExp(`(${Object.keys(EMOJI_ICONS).map((k) => k.replace(ESCAPE, "\\$&")).join("|")})\uFE0F?`, "gu");

/**
 * 絵文字1つを、管理UIの「アイコンの表示」に合わせて線のアイコンで出す（出さないを選べば消える）。絵文字そのものは出さない。
 * 線のアイコンは文字と同じ大きさ（1em）で、文字の色を使う
 */
export default function Glyph({ e, className }: { e: string; className?: string }) {
  const mode = useGlyphMode();
  const icon = EMOJI_ICONS[strip(e)];
  if (mode === "none" || !icon) return null;
  return <LibraryIcon name={icon} width="1em" height="1em" className={`inline-block align-[-0.15em] ${className ?? ""}`} />;
}

/** 文の中の絵文字を Glyph に置き換えて出す（「✋ 手持ちに登録する」など）。出さないときは、絵文字の後ろの空白も詰める */
export function GlyphText({ text }: { text: string }) {
  const mode = useGlyphMode();
  const parts = text.split(EMOJI_PATTERN);
  return (
    <>
      {parts.map((part, i) => {
        // split の奇数番目が絵文字（捕まえた組）
        if (i % 2 === 1) return <Glyph key={i} e={part} />;
        const prevWasDropped = mode === "none" && i > 0;
        return <Fragment key={i}>{prevWasDropped ? part.replace(/^[ \u3000]/, "") : part}</Fragment>;
      })}
    </>
  );
}
